// import hooks
import { useTranslation } from "react-i18next";
// import components
import { Container, Row, Col } from "react-bootstrap";

// import assets
import { redHeart, blueCart } from "../../utils/cards-svgs";
import "../../assets/css/cards.css";

const CardList2 = ({ list }) => {
    const [t] = useTranslation("global");
    return (
        <div className="bg-navyblue">
            <Container className="main-container card2-list-container">
                <h1 className="card-list-header">{list.title}</h1>
                <Row className="card2-list-main-div">
                    {list.items.map((i) => (
                        <Col className="card2-container" lg={4}>
                            <div className="card2">
                                <img
                                    src={i.img}
                                    alt="card image"
                                    className="card2-img"
                                />
                                <div className="card2-data">
                                    <h3 className="card2-h">{i.title}</h3>
                                    <a href={i.link} className="card1-link">
                                        <span>{i.linkTxt}</span>
                                        <div className="arrow-svg"></div>
                                    </a>
                                    <div className="card2-circles-div">
                                        <div className="card2-circle">
                                            <div className="card-svg-circle">
                                                {i.cart ? (
                                                    <img
                                                        src={redHeart}
                                                        alt="heart"
                                                        className="card-svg-img"
                                                    />
                                                ) : (
                                                    <div className="empty-heart-svg"></div>
                                                )}
                                            </div>
                                        </div>
                                        <div className="card2-circle">
                                            <div className="card-svg-circle">
                                                {i.cart ? (
                                                    <img
                                                        src={blueCart}
                                                        alt="cart"
                                                        className="card-svg-img"
                                                    />
                                                ) : (
                                                    <div className="empty-cart-svg"></div>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Col>
                    ))}
                    {list.viewMore && (
                        <Col className="card2-container" lg={4}>
                            <div className="card2">
                                <div className="view-more-card-div">
                                    <a
                                        href={list.viewMore}
                                        className="card1-link"
                                    >
                                        <span>{t("main.view-more")}</span>
                                        <div className="arrow-svg"></div>
                                    </a>
                                </div>
                            </div>
                        </Col>
                    )}
                </Row>
            </Container>
        </div>
    );
};

export default CardList2;
